import RougeOnlyRewards from './RougeOnlyRewards.f';
import { withRougeOnlyRewardsProps } from 'viewModel/content/BeautyInsider/withRougeOnlyRewardsProps';

export default withRougeOnlyRewardsProps(RougeOnlyRewards);
